/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Clear_TitleInputs */



/**
* | output |
* | --- |
* | "Clear Shortcut" |
*
* @param {Shortcut_Keys_Clear_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_clear_title = /** @type {((inputs?: Shortcut_Keys_Clear_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Clear_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Effacer le raccourci")
	if (locale === "de") return /** @type {LocalizedString} */ ("Klare Abkürzung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cancella collegamento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Очистить ярлык")
	if (locale === "es") return /** @type {LocalizedString} */ ("Borrar acceso directo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("清除快捷方式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ショートカットをクリア")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्पष्ट शॉर्टकट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atalho claro")
	return /** @type {LocalizedString} */ ("Clear Shortcut")
});